// import AlliedCamera from '../../routes/SmartInspect/Warren/assets/maintenance/5.1-allied-camera.png';
// import AlliedConnections from '../../routes/SmartInspect/Warren/assets/maintenance/5.2-allied-camera-connections.png';
import ChannelBoard from '../../routes/SmartInspect/Warren/assets/maintenance/5.3-channel-board.png';
import LEDHeader from '../../routes/SmartInspect/Warren/assets/maintenance/5.4-LED-header-board.png';
import ArchDoubleWide from '../../routes/SmartInspect/Warren/assets/maintenance/5.5-arch-double-wide-LED.png';
import ArchBoards from '../../routes/SmartInspect/Warren/assets/maintenance/5.6-arch-light-boards.png';
import WideBoards from '../../routes/SmartInspect/Warren/assets/maintenance/5.7-LED-wide-light-boards.png';
import PDP from '../../routes/SmartInspect/Warren/assets/equipment/3.12-PDP.png';
// import ArchConnecions from '../../routes/SmartInspect/Warren/assets/maintenance/5.8-light-arch-connections.png';
// import DoubleWideConnections from '../../routes/SmartInspect/Warren/assets/maintenance/5.9-double-wide-connections.png';
// import TriggerBoard from '../../routes/SmartInspect/Warren/assets/maintenance/5.10-trigger-board-connections.png';
import ArchHousing from '../../routes/SmartInspect/Warren/assets/maintenance/5.11-arch-light-housing.png';
import DoubleHousing from '../../routes/SmartInspect/Warren/assets/maintenance/5.12-double-wide-housing.png';
import styled from 'styled-components';
import BSCarousel from 'react-bootstrap/Carousel';

const CarouselComp = ({ className }) => {
	return (
		<BSCarousel className={className} fade variant="dark" interval={null}>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 1</h3>
					<h2 style={{ width: '50%', margin: 'auto' }}>
						Before replacing a LED board make sure to first troubleshoot the issue in <a href="/smart-inspect/warren/troubleshooting/hardware-troubleshooting">Light Arch Troubleshooting</a> section of this manual to ensure replacement is necessary.
					</h2>
				</BSCarousel.Caption>
			</BSCarousel.Item>

			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 2</h3>
					<p>
						Perform system power down/lock out as outlined in this manual and on the lock out placard located on the front of the <b>PDP</b>.
					</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={PDP} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: PDP</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>

			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 3</h3>
					<p>
						Locate the light/light housing with the bad LED board section (see <b>Figure 1, Figure 2</b>).
					</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ArchBoards} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: LED Arch Light/Channel Board Locations</figcaption>
					</figure>
					<figure>
						<img className="d-block w-100" src={WideBoards} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 2: LED Wide Light/Channel Board Locations</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>

			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 4</h3>
					<p>
						Locate the light box associated with the light/light housing with the bad LED board (see <b>Figure 1, Figure 2</b>).
					</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ArchBoards} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: LED Arch Light/Channel Board Locations</figcaption>
					</figure>
					<figure>
						<img className="d-block w-100" src={WideBoards} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 2: LED Wide Light/Channel Board Locations</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>

			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 5</h3>
					<p>
						Remove the associated power cable and trigger cable from the light box bulkhead by unscrewing the connector counter clockwise and pulling outward (see <b>Figure 1, Figure 2, Figure 3, Figure 4</b>).
					</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center', marginBottom: '1rem' }}>
					<figure>
						<img className="d-block w-100" src={LEDHeader} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: LED Header Board Connections</figcaption>
					</figure>
					<figure>
						<img className="d-block w-100" src={ArchDoubleWide} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 2: Arch/Double Wide LED Light Assemblies</figcaption>
					</figure>
				</div>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ArchBoards} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 3: LED Arch Light/Channel Board Locations</figcaption>
					</figure>
					<figure>
						<img className="d-block w-100" src={WideBoards} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 4: LED Wide Light/Channel Board Locations</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>

			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 6</h3>
					<p>Remove the two metric Allen screws that hold the light box cover in place and gently remove by pulling upward. This will give you access to the channel board and its associated connectors.</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center', marginBottom: '1rem' }}>
					<figure>
						<img className="d-block w-100" src={LEDHeader} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: LED Header Board Connections</figcaption>
					</figure>
					<figure>
						<img className="d-block w-100" src={ArchDoubleWide} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 2: Arch/Double Wide LED Light Assemblies</figcaption>
					</figure>
				</div>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ArchBoards} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 3: LED Arch Light/Channel Board Locations</figcaption>
					</figure>
					<figure>
						<img className="d-block w-100" src={WideBoards} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 4: LED Wide Light/Channel Board Locations</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>

			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 7</h3>
					<p>
						Locate the two black three pin LED board power VDC and ground GND connectors on the channel board associated with the light that has the bad LED board (see <b>Figure 1: Channel Board Connections</b>). These two connectors connect the channel board to the LED light/header board via power cable.
					</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ChannelBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Channel Board Connections</figcaption>
					</figure>
					<figure>
						<img className="d-block w-100" src={LEDHeader} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 2: LED Header Board Connections</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>

			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 8</h3>
					<p>
						Gently remove both connectors by grasping and pulling upward/outward to release. Ensure the channel board to LED board power cable is free and able to be pulled through the pass-through hole in the bottom of the light box. The cable will stay attached to the LED light board header during removal/installation (see <b>Figure 1, Figure 2</b>).
					</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ChannelBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Channel Board Connections</figcaption>
					</figure>
					<figure>
						<img className="d-block w-100" src={LEDHeader} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 2: LED Header Board Connections</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>

			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 9</h3>
					<p>
						Remove the LED light diffuser lens by removing the two black locking strips on either side of the light housing by gently peeling back (see <b>Figure 1, Figure 2</b>). Use clean gloves when working with the diffuser lens, it is very important not to scratch, crease or damage the lens during removal/installation. If damage occurs contact Inovision for a replacement.
					</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ArchHousing} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Arch Light LED Board Housing Components</figcaption>
					</figure>
					<figure>
						<img className="d-block w-100" src={DoubleHousing} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 2: Double Wide Light LED Board Housing Components</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
		</BSCarousel>
	);
};

const AlliedCameraSMP = styled(CarouselComp)`
	width: 65vw;
	margin: 0 auto;

	.carousel-inner {
		border-radius: 2em;
		min-height: 50vh;
	}

	.carousel-indicators {
		bottom: -20px;
	}

	.carousel-caption {
		position: relative;
		background: white;
		color: #000;
		width: 100%;
		left: 0;
		right: 0;
		bottom: 0;

		& h3 {
			text-align: center;
		}
	}

	@media screen and (max-width: 480px) {
		width: 89vw;
	}
`;

export default AlliedCameraSMP;
